import { Empty, Input, Modal } from "antd";
import dayjs from "dayjs";
import React, { useState } from "react";
import { useMutation, useQuery } from "react-query";
import { useMediaQuery } from "react-responsive";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import {
	Loading,
	NoteComponent,
	PageLoading,
	SplitPane,
} from "../../components";
import MainLayout from "../../components/MainLayout/MainLayout";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import {
	btnStyle,
	floatBtn,
	hideScrollbar,
	inputStyle,
	LandingTitle,
} from "../../lib/styles/styleLibrary";
import { createNote, fetchAllNotes } from "../../redux/actions/notes";

const NotesWrapper = styled.div`
	${tw`p-4 md:(pl-12 pr-12 pt-10) pb-0 h-full w-full`}
`;

const NewNoteWrapper = styled.div`
	${tw`p-1 md:p-8 pt-4 h-full bg-white w-full flex flex-col container`}
	height: 80vh;
	box-shadow: 0px 30px 60px rgba(32, 56, 85, 0.05);
	border-radius: 10px;
	@media (max-width: 1217px) {
		height: auto;
	}
`;

const MakeNotes = (props) => {
	const isMobile = useMediaQuery({ maxWidth: 1217 });
	const [newNoteModal, setNewNoteModal] = useState(false);
	const { data, refetch, isLoading } = useQuery("notes", fetchAllNotes, {
		refetchOnWindowFocus: false,
		// refetchOnmount: true,
	});
	const notes = data?.data?.notes;
	// console.log(notes);

	const MyNotes = () => {
		return (
			<div
				tw="flex flex-row flex-wrap gap-4 container mt-4 justify-center md:justify-start"
				css={hideScrollbar}>
				{isLoading ? (
					<PageLoading />
				) : isEmpty(notes) ? (
					<div tw="h-full w-full mt-12 flex items-center justify-center">
						<Empty
							description={"You are yet to create a note 📝"}
						/>
					</div>
				) : (
					notes?.map((n, i) => {
						const createDate = n.createdAt;
						return (
							<NoteComponent
								data={n}
								cardTitle={n.title}
								date={dayjs(createDate).format("ddd, MMM DD")}
								key={i}
								refetch={refetch}>
								{n.description}
							</NoteComponent>
						);
					})
				)}
			</div>
		);
	};

	const NewNotes = () => {
		const { TextArea } = Input;
		const [fields, setFields] = useState({
			title: "",
			description: "",
		});
		const { mutateAsync: handleCreate, isLoading: cnloading } =
			useMutation(createNote);

		const handeNewNote = async (e) => {
			e.preventDefault();
			if (isEmpty(fields.title) || isEmpty(fields.description)) {
				Toast.fire({
					icon: "error",
					title: `All fields are required`,
				});
				return;
			}
			try {
				const response = await handleCreate(fields);
				console.log(response.data);
				const { hasError } = response.data;
				if (hasError) {
					const { title, message } = response.errors;
					Toast.fire({
						icon: "error",
						title: `${title}\n${message}`,
					});
				} else {
					Toast.fire({
						icon: "success",
						title: `Note created successfully`,
					});
					refetch();
				}
			} catch (err) {
				console.log(err);
				return false;
			}
		};

		return (
			<NewNoteWrapper>
				<h3
					tw="font-semibold tracking-wider"
					style={{ fontSize: "15px" }}>
					Draft New Note
				</h3>

				<div tw="mt-4">
					<Input
						placeholder="Title"
						type="text"
						css={inputStyle}
						value={fields.title}
						onChange={(e) =>
							setFields({ ...fields, title: e.target.value })
						}
						tw="w-full text-xs! px-3 py-6 rounded-md"
					/>
				</div>

				<div tw="h-4/5">
					<TextArea
						placeholder="Write body here?"
						autoSize={{ minRows: 10 }}
						value={fields.description}
						onChange={(e) =>
							setFields({
								...fields,
								description: e.target.value,
							})
						}
						tw="mb-4 text-xs! h-full! p-4 rounded! box-border"
						css={inputStyle}
					/>
				</div>
				<div tw="mt-8 mb-8">
					<button
						css={btnStyle}
						tw="rounded-md"
						onClick={(e) => handeNewNote(e)}>
						{cnloading ? <Loading /> : "Done"}
					</button>
				</div>
			</NewNoteWrapper>
		);
	};

	return (
		<MainLayout>
			<NotesWrapper>
				{/* Photo Section */}
				<LandingTitle tw="text-2xl font-bold leading-8 whitespace-pre">
					My Notes
				</LandingTitle>

				<div
					tw="w-full overflow-y-scroll"
					css={hideScrollbar}
					style={{ height: isMobile ? "32rem" : "auto" }}>
					<SplitPane
						wrapDirection={"column"}
						hideRightSide={isMobile ? true : false}
						left={<MyNotes />}
						right={<NewNotes />}
					/>
				</div>

				<Modal
					footer=""
					visible={newNoteModal}
					centered
					onCancel={() => setNewNoteModal(false)}
					maskClosable={false}>
					<NewNotes />
				</Modal>
				{isMobile && (
					<button
						css={floatBtn}
						onClick={() => setNewNoteModal(true)}>
						+
					</button>
				)}
			</NotesWrapper>
		</MainLayout>
	);
};

export default MakeNotes;
